const FormHelperText = () => {
  return (
    <small>
      Fields marked with <strong className="text-danger">*</strong> are
      mandatory.
    </small>
  );
};

export default FormHelperText;
